import type { ChildProtectionInvolvementResponse } from "@lbcrm-api/child-protection/clearances/board/child-protection-clearances.responses";
import { useContext } from "react";
import { AbilityContext } from "src/authentication/context/Can";
import { Action } from "src/casl/Action";
import useSWR from "swr";

export const MY_CHILD_PROTECTION_INVOLVEMENT_KEY = "/profile/child-protection-involvement";

/**
 * A yes or no, so the home screen reads no clearance (`[CLR60B]`). Undefined while it loads, so Home
 * can wait for it, and a plain no for somebody it's switched off for, since that never arrives.
 */
export const useMyChildProtectionInvolvement = () => {
    const ability = useContext(AbilityContext);
    const canRead = ability.can(Action.Read, "ChildProtectionClearance");

    // Somebody holding no role would only be refused
    const { data } = useSWR<ChildProtectionInvolvementResponse>(canRead ? MY_CHILD_PROTECTION_INVOLVEMENT_KEY : null);

    return { involved: canRead ? data?.involved : false };
};
